import React, { ChangeEvent } from "react";
import { Button } from "@material-ui/core";



export interface FileButtonProps {
  onPick?: (path: string, base64?: string) => void
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  color?: "default" | "inherit" | "primary" | "secondary";
  variant?: "text" | "outlined" | "contained";
  extension?: string;
  disabled?: boolean;
}

export default function FileButton(props: FileButtonProps) {
  const { children, onPick, extension, ...rest } = props;
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!onPick) {
      return;
    }
    const { value, files } = event.target;
    if (
      !value || (extension && !value.endsWith(extension)) ||
      !files || files.length !== 1
    ) {
      onPick(value);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      onPick(value, (reader.result as string).split(',')[1]);
    }
    reader.onerror = () => {
      onPick(value);
    }
    reader.readAsDataURL(files[0])
  }
  return (
    <Button {...rest} component="label">
      {children}
      <input
        type="file"
        onChange={handleOnChange}
        style={{ display: "none" }}
      />
    </Button>
  )
}